export const langChangeRoom = {
    "arm": {
        tr_changeData: "Փոփոխել Կոնֆերենսի տվյալները",
        tr_meetingTitle: "Հանդիպման անունը",
        tr_numberOfParticipants: "Հանդիպման մասնակիցների քանակը",
        tr_selectUsers: "Ընտրել օգտվողներին",
        tr_selectTime: "Ընտրեք ձեր հանդիպման ժամը",
        tr_acceptTheChange: "Ընդունել փոփոխությունը",
        tr_participants: "Մասնակիցներ",
        tr_dayAndTime: "Օր և ժամ",
        tr_chooseTime: "Ժամը անհրաժեշտ է ընտրել սկսած ",
    },
    "eng": {
        tr_changeData: "Change conference data",
        tr_meetingTitle: "Meeting title",
        tr_numberOfParticipants: "Number of participants to the meeting",
        tr_selectUsers: "Select users",
        tr_selectTime: "Select the time of your",
        tr_acceptTheChange: "Accept the change",
        tr_participants: "Participants",
        tr_dayAndTime: "Day and time",
        tr_chooseTime: "The hour must be selected from ",
    },
    "fr": {
        tr_changeData: "Modifier les informations sur la conférence",
        tr_meetingTitle: "Titre de la réunion",
        tr_numberOfParticipants: "Nombre de participants à la réunion",
        tr_selectUsers: "Sélectionnez les utilisateurs",
        tr_selectTime: "Sélectionnez l’heure de votre réunion.",
        tr_acceptTheChange: "Accepter la modification",
        tr_participants: "participants",
        tr_dayAndTime: "Jour et heure",
        tr_chooseTime: "L'heure doit être choisie parmi ",
    },
    "arb": {
        tr_changeData: "تعديل بيانات المكالمة الجماعيّة",
        tr_meetingTitle: "اسم الاجتماع",
        tr_numberOfParticipants: "عدد المشاركين في الاجتماع",
        tr_selectUsers: "اختيار المستخدمين",
        tr_selectTime: "اختيار ساعة اجتماعكم",
        tr_acceptTheChange: "قبول التعديل",
        tr_participants: "الحاضرين",
        tr_dayAndTime: "اليوم والوقت",
        tr_chooseTime: "يجب اختيار الساعة من ",
    },
    "rus": {
        tr_changeData: "Изменить данные конференции",
        tr_meetingTitle: "Название встречи",
        tr_numberOfParticipants: "Количество участников встречи",
        tr_selectUsers: "Выберите пользователей",
        tr_selectTime: "Выберите время встречи",
        tr_acceptTheChange: "Сохранить изменения",
        tr_participants: "Участники",
        tr_dayAndTime: "День и время",
        tr_chooseTime: "Время нужно выбрать начиная с ",
    }
}